import Header from '../../components/Header';
import SettingsTab from '../../components/manager/SettingsTab';
import OwnerSidebar from '../../components/owner/OwnerSidebar';

const OwnerSettingsScreen = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <OwnerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Settings'} orderSubtitle={'Manage system defaults'} showButton={false} /> 
          <section className='mt-10 flex gap-5'>
                 <SettingsTab /> 
          </section>
        </main>
      </section>

    </>
  )
}
export default OwnerSettingsScreen